import { Fragment, useEffect, useState } from 'react'
import cn from 'classnames'

const TILES = [3, 3, 2, 6]
const OPS = ['×', '×', '+'] // 3 × 3 × 2 + 6 = 24

// Looping landing-page demo of the objective:
//   tiles  →(2s)→  operators fade in  →(1s)→  "= 24" appears + tiles turn green
//   →(2s)→ reset and repeat.
export const Game24Demo = () => {
  const [step, setStep] = useState(0) // 0: tiles · 1: +operators · 2: +result/green

  useEffect(() => {
    const timers: number[] = []
    const run = () => {
      setStep(0)
      timers.push(window.setTimeout(() => setStep(1), 2000))
      timers.push(window.setTimeout(() => setStep(2), 3000))
      timers.push(window.setTimeout(run, 5000))
    }
    run()
    return () => timers.forEach((t) => window.clearTimeout(t))
  }, [])

  const solved = step >= 2

  return (
    <div className="flex items-center justify-center gap-1.5">
      {TILES.map((n, i) => (
        <Fragment key={i}>
          <div
            className={cn(
              'flex h-11 w-11 items-center justify-center rounded-lg text-xl font-bold text-white shadow transition-colors duration-500',
              solved ? 'bg-[#398874]' : 'bg-[#820458]'
            )}
          >
            {n}
          </div>
          {i < OPS.length && (
            <span
              className={cn(
                'w-4 text-center text-lg font-semibold text-gray-500 transition-all duration-300',
                step >= 1 ? 'scale-100 opacity-100' : 'scale-50 opacity-0'
              )}
              style={{ transitionDelay: step >= 1 ? `${i * 120}ms` : '0ms' }}
            >
              {OPS[i]}
            </span>
          )}
        </Fragment>
      ))}
      <span
        className={cn(
          'ml-1 text-xl font-bold text-[#398874] transition-all duration-300',
          solved ? 'translate-x-0 opacity-100' : '-translate-x-1 opacity-0'
        )}
      >
        = 24
      </span>
    </div>
  )
}
